/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import { CategoryState, CategoryAction, CategoryActionTypes } from './types';

const INITIAL_STATE: CategoryState = {
  categorys: [],
  subCategoriesSelected: [],
  categorySelected: '',
  subCategorySelected: '',
  error: false,
  loading: false,
  parent_id: '',
  short_description: '',
  filters: {
    id: '',
    short_description: '',
  },
  components: {
    categoryCurrentId: '',
    isLoading: false,
    data: {}
  }
};

export default function category(
  state = INITIAL_STATE,
  action: CategoryAction,
): CategoryState {
  switch (action.type) {
    case CategoryActionTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case CategoryActionTypes.LOAD_SUCCCES:
      return {
        ...state,
        categorys: action.payload.data,
        loading: false,
        error: false,
      };
    case CategoryActionTypes.LOAD_FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
      };
    case CategoryActionTypes.SET_SUBCATEGORIES:
      return {
        ...state,
        subCategoriesSelected: action.payload.data
      }
    case CategoryActionTypes.SET_CATEGORY_SELECTED:
      return {
        ...state,
        categorySelected: action.payload.categoryId,
        subCategorySelected: '', // Reset subcategory when category changes
      }
    case CategoryActionTypes.SET_SUBCATEGORY_SELECTED:
      return {
        ...state,
        subCategorySelected: action.payload.subcategoryId,
      }
    case CategoryActionTypes.RESET_CATEGORIES_SELECTED:
      return {
        ...state,
        categorySelected: '',
        subCategorySelected: '',
        subCategoriesSelected: [],
      }
    case CategoryActionTypes.SEARCH_COMPONENTS:
      return {
        ...state,
        components: {
          ...state.components,
          isLoading: true,
        }
      }
    case CategoryActionTypes.SEARCH_COMPONENTS_RESPONSE:
      return {
        ...state,
        components: {
          ...state.components,
          data: {
            ...state.components.data,
            [action.payload.categoryId]: action.payload.data,
          },
          categoryCurrentId: action.payload.categoryId,
          isLoading: false,
        }
      }
    case CategoryActionTypes.SEARCH_COMPONENTS_ALREADY_EXIST:
      return {
        ...state,
        components: {
          ...state.components,
          categoryCurrentId: action.payload.categoryId,
          isLoading: false,
        }
      }
    default:
      return state;
  }
}
